export const AppRoutes = function routes($stateProvider) {
    'ngInject';

    $stateProvider
        .state({
            name: 'start',
            component: 'startView'
        })
        .state({
            name: 'draw',
            component: 'drawView'
        })
        .state({
            name: 'design',
            component: 'designView',
            params: {
                'back': false
            }
        })
        .state({
            name: 'summary',
            component: 'summaryView'
        });

}



// WEBPACK FOOTER //
// ./src/js/routes.js